import { IconTab } from "@/src/components/iconTab";
import { Complication, Hospitalisation, Patient } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, jsonAbstract } from "@/src/utils/utils";
import { FaStethoscope } from "react-icons/fa";
import { getStandardConfidentiality } from "../../patients/confidentialitiesHook";
import openEvolutionItemStandardForm from "../openEvolutionItemStandardForm";
import { CONFIG } from "@/src/data/globalVariables";
import { RiLungsLine, RiMedicineBottleLine } from "react-icons/ri";
import { openSnomedConceptPicker } from "../../snomed/SnomedConceptPicker";
import { LiaUserInjuredSolid } from "react-icons/lia";

function ComplicationButton({
  patient,
  parent,
  onSave,
}: {
  patient: Patient;
  parent: Hospitalisation;
  onSave: (item: Complication) => void;
}) {
  return (
    <IconTab
      id={"complication"}
      activeTabId={null}
      isHorizontal={true}
      name={"Complication"}
      icon={<LiaUserInjuredSolid size={25} />}
      onChange={async () => {
        await openSnomedConceptPicker({
          category: "diagnostic",
          parentIds: ["disease", "finding"],
          title: "Choisir une complication",
          onSelect: async (newReference) => {
            let item: Complication = {
              type: "complication",
              patient,
              creator: getUserId(),
              parent,
              reference: newReference,
              refAnswer: {
                patient,
                creator: getUserId(),
                fieldAnswers: [],
                reference: newReference,
              },
              confidentiality: getStandardConfidentiality(patient),
              readBy: [getUserId()],
            };

            return await openEvolutionItemStandardForm({
              item,
              patient,
              onConfirm: async (newItem) => {
                newItem = await apiFetch("complications", "addOne", {
                  complication: newItem,
                });
                onSave(newItem);
              },
            });
          },
        });
      }}
    />
  );
}

export default ComplicationButton;
